import { Navigation, Swiper } from 'swiper';
import { addZero } from '@/modules/functions';

export class CardProductImageSlider {
  slider;
  current;
  total;

  constructor() {}

  init() {
    const block = document.querySelector('.card-product-images');
    if (!block) return;

    Swiper.use([Navigation]);

    this.current = document.querySelector('.card-product-images-count-current');
    this.total = document.querySelector('.card-product-images-count-total');

    this.total.innerText = addZero(
      block.querySelectorAll('.swiper-slide').length
    );
    this.current.innerText = addZero(1);

    this.slider = new Swiper('.card-product-images-slider', {
      loop: true,
      navigation: {
        prevEl: '.card-product-images-prev',
        nextEl: '.card-product-images-next',
      },
      on: {
        slideChange: (swiper) => {
          this.current.innerText = addZero(swiper.realIndex + 1);
        },
      },
      breakpoints: {
        0: {
          centeredSlides: false,
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          centeredSlides: true,
          slidesPerView: 'auto',
          spaceBetween: 30,
        },
      },
    });
  }
}
